export default "__VITE_ASSET__DSGIKEn1__"